<template>
  <div>
    <div class="g-tab-warp">
      <div
        class="tab-bar-goback"
        @click="goBack"
      >
        <!-- <img
          src="./../../assets/img/goback.png"
          alt
        /> -->
      </div>
      <!-- staticNavName: 控制只显示nav -->
      <ul v-if="!staticNavName" class="tab-bar clearfix">
        <li
          v-for="(nav, index) in navList"
          :key="index"
          :class="{
            pre: nav.targetRouterName === currentItem.targetRouterName,
          }"
        >
          <nav-link-item :nav="nav" />
        </li>
      </ul>
      <!-- 标题 -->
      <p v-if="staticNavName" class="title-style tab-bar clearfix">
        {{ staticNavName }}
      </p>
      <!-- 切换按钮 -->
      <!-- <p
        style="color: #fff; font-size: 0.24rem;"
        @click="change()"
      >
        切换
      </p> -->
      <!-- 搜索入口屏蔽 -->
      <!-- <a
        v-ptt="['click', 'search-main', '首页搜索栏点击']"
        href="javascript:false;"
        class="top-search"
        @touchstart.stop="toSearch()"
      >
        正在热搜: {{ _keyword }}
      </a> -->
    </div>
  </div>
</template>

<script>
import NavLinkItem from './components/NavLinkItem';
import backHandle from '@/utils/core/backHandle';

export default {
  components: { NavLinkItem },
  props: {
    staticNavName: {
      type: String,
      default: '',
    },
    navList: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentItem: {
      type: Object,
      required: true,
      default: () => ({ targetRouterName: '' }),
    },
  },
  data() {
    return {
      state: false,
    };
  },
  computed: {
    _keyword() {
      return this.$store.state.hotKeyWord.title;
    },
  },
  mounted() {},
  created() {},
  methods: {
    change() {
      if (this.state) {
        document.querySelector('#g-layer').classList.remove('right');
        this.state = false;
      } else {
        document.querySelector('#g-layer').classList.add('right');
        this.state = true;
      }
    },
    goBack() {
      backHandle('backTogame');
    },

    toSearch() {
      this.$router.push({ name: 'searchnew', params: { form: this.$route.name } });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-bar-goback {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.85rem;
  height: 0.62rem;
  display: flex;
  align-items: center;
  background: url(~@img/close_top2.png) no-repeat center;
  background-size: cover;
    img {
    height: 100%;
    display: none;
  }
}

// .now {
//   color: yellow;
// }

.g-tab-warp {
  height: 0.62rem;
  display: flex;
  justify-content: space-between;
  background: url(~@img/all_tit.png) no-repeat left bottom;
  position: relative;
  align-items: center;
  padding-left: .24rem;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255,255,255,0.1);

  // .g-tab-list {
  //   .scroll-content {
  //     width: 116%;
  //     display: inline-flex;
  //   }
  // }
  // .g-sub-tab {
  //   width: 100%;
  // }

  .tab-bar li {
    margin: 0;
    width: 1.56rem;
    height: 0.62rem;
    line-height: 0.62rem;
    padding: 0;
    box-sizing: border-box;
  }

  .tab-bar /deep/ .nav-link-item {
    display: block;
    height: 100%;
    text-align: center;
    padding: 0;
    line-height: 0.62rem;
    font-weight: normal;
  }

  .tab-bar li.pre {
    background: url(~@img/be_tit.png) no-repeat;
    background-size: cover;
  }

  .tab-bar li.pre /deep/ .nav-link-item::after {
    background: #fff;
  }

  .tab-bar li.pre /deep/ .nav-link-item {
    padding: 0;
  }

  .title-style{
    width: calc(100% - 0.85rem);
    font-size: 0.26rem;
    color: #fff;
    padding-left: 0.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .more {
    width: 0.27rem;
    height: 0.24rem;
    padding: 0 0.2rem;

    a {
      display: block;
      width: 0.27rem;
      height: 0.27rem;
      margin-top: 0.24rem;
      background: url(~@img/icon/menu-search.png) no-repeat;
      background-size: 2rem 0.8rem;
      background-position: 0 -0.56rem;
      position: relative;
    }
  }
}

.top-search {
  width: 3.5rem;
  height: 0.42rem;
  background: url(../../assets/img/search-input.png) no-repeat left/contain;
  position: absolute;
  right: 1.09rem;
  top: 0.1rem;
  box-sizing: border-box;
  padding-right: 0.45rem;
  padding-left: 0.55rem;
  line-height: 0.42rem;
  font-size: 0.22rem;
  color: #c8d3e6;
  // z-index: 5;
  outline: none;
  border: none;
  border-radius: 0.05rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-search.on {
  display: none;
}

.top-search::-webkit-input-placeholder {
  color: #d0cfcf;
}
</style>
